module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmb250cy9yb2JvdG8tdjE1LWxhdGluLXJlZ3VsYXItM2QzYTUzLnN2ZyI7"


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module id = 828
// module chunks = 2